import { type Product } from '@/mocks/products';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { useLocation } from 'react-router-dom';

interface ProductCardProps {
  product: Product;
}

export default function ProductCard({ product }: ProductCardProps) {
  const { t } = useTranslation();
  const location = useLocation();
  const currentLang = location.pathname.split('/')[1] || 'en';

  return (
    <Link
      to={`/${currentLang}/product/${product.id}`}
      className="group block rounded-xl bg-background-50 border border-background-200/60 overflow-hidden hover:border-primary-300/60 hover:shadow-md transition-all duration-300"
    >
      <div className="relative aspect-square overflow-hidden bg-background-100">
        <img
          src={product.image}
          alt={product.name}
          className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
          loading="lazy"
        />
      </div>
      <div className="p-3 md:p-4">
        <h3 className="text-xs md:text-sm font-medium text-foreground-800 leading-snug line-clamp-2 mb-2 min-h-[2.5em]">
          {product.name}
        </h3>
        <div className="flex items-center justify-between gap-2">
          <div className="flex flex-col">
            <span className="text-sm md:text-base font-bold text-primary-700">
              ¥{product.priceYuan}
            </span>
            <span className="text-xs text-foreground-500">
              ≈ ${product.priceUsd.toFixed(2)}
            </span>
          </div>
          <span className="inline-flex items-center gap-1 px-2.5 py-1 rounded-full bg-primary-500 text-background-50 text-xs font-medium whitespace-nowrap group-hover:bg-primary-600 transition-colors">
            <i className="ri-shopping-cart-line text-xs" />
            {t('productCard.buyNow')}
          </span>
        </div>
      </div>
    </Link>
  );
}